import React, { useState, useEffect } from 'react';
import { getFeeLogisticoSellersApi } from "../../../../api/axios";
import { toast } from "react-toastify";
import BigSpinner from "../../../General/BigSpinner";

export default function TablaFeeLogistico() {
  const [isLoading, setIsLoading] = useState(true);
  const [feeLogisticos, setFeeLogisticos] = useState([]);

  useEffect(() => {
    let response = getFeeLogisticoSellersApi();

    response.then(res => {
      setFeeLogisticos(res.data.feeLogisticos)
    }).catch(err => {
      (err.response.data.errores)
        ? err.response.data.errores.forEach(error => toast.warn(error))
        : toast.error("No pudieron ser obtenidos los fee logísticos");
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);


  return (
    <div className="card" style={{ maxHeight: "275px" }}>
      {isLoading ?  <BigSpinner /> :
        <div className="animated fadeIn">
          {feeLogisticos && feeLogisticos.length > 0 ?
            <div className="table-responsive" style={{ maxHeight: "275px", overflowY: "auto" }}>
              <table className="table">
                <thead style={{ position: "sticky", top: 0, backgroundColor: "white" }}>
                  <tr>
                    <th><small>Id</small></th>
                    <th><small>Escala</small></th>
                    <th><small>Amba</small></th>
                    <th><small>Interior</small></th>
                    <th><small>Patagonia</small></th>
                  </tr>
                </thead>
                <tbody>
                  {feeLogisticos.map((fee, index) => {
                    return (
                      <tr key={index} className="hover-background-color">
                        <td><small>{fee.idFee}</small></td>
                        <td><small>{fee.escala}</small></td>
                        <td><small>{fee.amba}</small></td>
                        <td><small>{fee.interior}</small></td>
                        <td><small>{fee.patagonia}</small></td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            :
            <h6 className="d-flex justify-content-center m-t-40 m-b-40">
              NO SE ENCONTRARON FEE LOGÍSTICOS
            </h6>
          }
        </div>
      }
    </div>
  )
}